"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionGetBlobFromFile = exports.FunctionRemoveEmptyValue = exports.FunctionSelectFields = exports.FunctionCheckDifferences = exports.FunctionChangeNormalCaseToSnakeCase = exports.FunctionChangeNormalCaseToCamelCase = exports.FunctionChnageCamelCaseToNormalCase = exports.FunctionChangeSnakeCaseToNormalCase = exports.FunctionChangeSnakeCaseToCamelCase = exports.FunctionChangCamelCaseToSnakeCase = exports.FunctionMergeObjectByKey = exports.FunctionGroupingArrayByKey = exports.FunctionSortDataByArrayKeys = exports.FunctionSelectArray = exports.FunctionRemoveArray = exports.FunctionGetNumberFromString = exports.FunctionGetAlphabetFromString = exports.FunctionGetFileFromUrl = exports.FunctionGetBlobFromUrl = exports.FunctionGetFileFromBlob = exports.FunctionGetBlobFromBase64 = exports.FunctionGetBase64FromBlob = exports.FunctionGetUrlFromFile = exports.FunctionGetFileFromBase64 = exports.FunctionGetBase64FromUrl = exports.FunctionCalcurateTimeDifferences = exports.FunctionGetYouTubeId = exports.FunctionFormatGlobalDate = exports.FunctionFormatThaiDate = exports.FunctionZeroPad = exports.FunctionOpenInNewTab = void 0;
const FunctionOpenInNewTab = (url) => {
    if (!url)
        return;
    window.open(url, "_blank");
};
exports.FunctionOpenInNewTab = FunctionOpenInNewTab;
const FunctionZeroPad = (num, numZeros) => {
    var n = Math.abs(num);
    var zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
    var zeroString = Math.pow(10, zeros).toString().substr(1);
    if (num < 0) {
        zeroString = "-" + zeroString;
    }
    return zeroString + n;
};
exports.FunctionZeroPad = FunctionZeroPad;
const FunctionFormatThaiDate = (date) => {
    const d = new Date(date);
    const month = new Array();
    month[0] = "มกราคม";
    month[1] = "กุมภาพันธ์";
    month[2] = "มีนาคม";
    month[3] = "เมษายน";
    month[4] = "พฤษภาคม";
    month[5] = "มิถุนายน";
    month[6] = "กรกฎาคม";
    month[7] = "สิงหาคม";
    month[8] = "กันยายน";
    month[9] = "ตุลาคม";
    month[10] = "พฤศจิกายน";
    month[11] = "ธันวาคม";
    const dd = d.getDate();
    const mm = month[d.getMonth()];
    const yyyy = d.getFullYear() + 543;
    return `${dd} ${mm} ${yyyy}`;
};
exports.FunctionFormatThaiDate = FunctionFormatThaiDate;
const FunctionFormatGlobalDate = (date) => {
    const d = new Date(date);
    const month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";
    const dd = d.getDate();
    const mm = month[d.getMonth()];
    const yyyy = d.getFullYear() + 543;
    return `${dd} ${mm} ${yyyy}`;
};
exports.FunctionFormatGlobalDate = FunctionFormatGlobalDate;
const FunctionGetYouTubeId = (url) => {
    if (!url)
        return;
    let ID = "";
    url = url
        .replace(/(>|<)/gi, "")
        .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
    }
    else {
        ID = url;
    }
    return ID;
};
exports.FunctionGetYouTubeId = FunctionGetYouTubeId;
const FunctionCalcurateTimeDifferences = (input) => {
    if (input) {
        const date = new Date(input);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const diffSeconds = Math.floor(diff / 1000);
        const diffMinutes = Math.floor(diff / 60000);
        const diffHours = Math.floor(diff / 3600000);
        const diffDays = Math.floor(diff / 86400000);
        const diffWeeks = Math.floor(diff / 604800000);
        const diffMonths = Math.floor(diff / 2629800000);
        const diffYears = Math.floor(diff / 31557600000);
        if (diffSeconds < 60) {
            return "just now";
        }
        if (diffMinutes < 60) {
            return diffMinutes + " minutes ago";
        }
        if (diffHours < 24) {
            return diffHours + " hours ago";
        }
        if (diffDays < 7) {
            return diffDays + " days ago";
        }
        if (diffWeeks < 4) {
            return diffWeeks + " weeks ago";
        }
        if (diffMonths < 12) {
            return diffMonths + " months ago";
        }
        return diffYears + " years ago";
    }
    else {
        return "please enter a date";
    }
};
exports.FunctionCalcurateTimeDifferences = FunctionCalcurateTimeDifferences;
const FunctionGetBase64FromUrl = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield new Promise((resolve) => {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    const base64data = reader.result;
                    resolve(base64data);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open("GET", url);
            xhr.responseType = "blob";
            xhr.send();
        });
    }
    catch (error) {
        console.error("FunctionGetBase64FromUrl : ", error);
    }
});
exports.FunctionGetBase64FromUrl = FunctionGetBase64FromUrl;
const FunctionGetFileFromBase64 = (input, fileName = "Filename") => {
    try {
        var arr = input.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    }
    catch (error) {
        console.error("FunctionGetFileFromBase64 :", error);
    }
};
exports.FunctionGetFileFromBase64 = FunctionGetFileFromBase64;
const FunctionGetUrlFromFile = (file) => {
    try {
        return URL.createObjectURL(file);
    }
    catch (error) {
        console.error("FunctionGetUrlFromFile : ", error);
    }
};
exports.FunctionGetUrlFromFile = FunctionGetUrlFromFile;
const FunctionGetBase64FromBlob = (blob) => {
    try {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    catch (error) {
        console.error("FunctionGetBase64FromBlob : ", blob);
    }
};
exports.FunctionGetBase64FromBlob = FunctionGetBase64FromBlob;
const FunctionGetBlobFromBase64 = (input) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return new Promise((resolve) => {
            fetch(input, {
                method: "GET",
            })
                .then((response) => response.blob())
                .then((blob) => {
                resolve(blob);
            });
        });
    }
    catch (error) {
        console.error("FunctionGetBlobFromBase64 : ", input);
    }
});
exports.FunctionGetBlobFromBase64 = FunctionGetBlobFromBase64;
const FunctionGetFileFromBlob = (blob, fileName = "Filename") => {
    try {
        const file = new File([blob], `${fileName}.${blob.type.split("/")[1] || "png"}`, {
            type: blob.type,
        });
        return file;
    }
    catch (error) {
        console.error("FunctionGetFileFromBlob : ", error);
    }
};
exports.FunctionGetFileFromBlob = FunctionGetFileFromBlob;
const FunctionGetBlobFromUrl = (url) => {
    try {
        return new Promise((resolve) => {
            fetch(url, {
                method: "GET",
            })
                .then((response) => response.blob())
                .then((blob) => {
                resolve(blob);
            });
        });
    }
    catch (error) {
        console.error("FunctionGetBlobFromUrl : ", url);
    }
};
exports.FunctionGetBlobFromUrl = FunctionGetBlobFromUrl;
const FunctionGetFileFromUrl = (url, fileName = "Filename") => {
    try {
        return new Promise((resolve) => {
            fetch(url, {
                method: "GET",
            })
                .then((response) => response.blob())
                .then((blob) => {
                let b = blob;
                b.lastModifiedDate = new Date();
                b.name = fileName;
                resolve(b);
            });
        });
    }
    catch (error) {
        console.error("FunctionGetFileFromUrl : ", error);
    }
};
exports.FunctionGetFileFromUrl = FunctionGetFileFromUrl;
const FunctionGetAlphabetFromString = (input) => {
    try {
        return input.replace(/[^A-Za-z]/g, "");
    }
    catch (error) {
        console.error("FunctionGetAlphabetFromString : ", error);
    }
};
exports.FunctionGetAlphabetFromString = FunctionGetAlphabetFromString;
const FunctionGetNumberFromString = (input) => {
    try {
        return input.replace(/[^0-9]/g, "");
    }
    catch (error) {
        console.error("FunctionGetNumberFromString : ", error);
    }
};
exports.FunctionGetNumberFromString = FunctionGetNumberFromString;
const FunctionRemoveArray = (data = [], remove = []) => {
    try {
        return data.filter((item) => {
            return remove.indexOf(item) < 0;
        });
    }
    catch (error) {
        console.error("FunctionRemoveArray : ", error);
    }
};
exports.FunctionRemoveArray = FunctionRemoveArray;
const FunctionSelectArray = (data = [], select = []) => {
    try {
        return data.filter((item) => {
            return select.indexOf(item) >= 0;
        });
    }
    catch (error) {
        console.error("FunctionSelectArray : ", error);
    }
};
exports.FunctionSelectArray = FunctionSelectArray;
const FunctionSortDataByArrayKeys = (array = [], key, keys = []) => {
    try {
        let sortArray = array.sort((a, b) => {
            const aKey = a[key];
            const bKey = b[key];
            return keys.indexOf(aKey) - keys.indexOf(bKey);
        });
        return sortArray;
    }
    catch (error) {
        console.error("FunctionSortArrayByArrayKeys : ", error);
    }
};
exports.FunctionSortDataByArrayKeys = FunctionSortDataByArrayKeys;
const FunctionSortArrayByArrayKeys = (array = [], key, keys = []) => {
    try {
        let insertIndex = (array === null || array === void 0 ? void 0 : array.map((row, index) => {
            const findIndex = keys.findIndex((name) => {
                return name === row[key];
            });
            return {
                value: row === null || row === void 0 ? void 0 : row.value,
                index,
                newIndex: findIndex,
                [key]: row[key],
            };
        })) || [];
        let newArray = insertIndex === null || insertIndex === void 0 ? void 0 : insertIndex.sort((a, b) => {
            return a.newIndex - b.newIndex;
        });
        return newArray;
    }
    catch (error) {
        console.error("FunctionSortArrayByArrayKeys : ", error);
    }
};
const FunctionSelectFromMerge = (array = [], key = "", select = []) => {
    try {
        const res = array.map((item) => {
            var _a;
            let thisValue = (_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.map((item) => {
                let thisSelect = {};
                select.forEach((name) => {
                    thisSelect[name] = item[name];
                });
                return thisSelect;
            });
            return {
                key: item[key],
                value: thisValue,
            };
        });
        return res;
    }
    catch (error) {
        console.error("FunctionSelectFromMerge : ", error);
    }
};
const FunctionGroupingArrayByKey = (arrayData = [], key = "", select = [], sortKeys = []) => {
    try {
        let output = arrayData.reduce(function (previous, current) {
            let occurs = previous.reduce(function (previous_item, current_item, current_index) {
                return current_item[key] === current[key]
                    ? current_index
                    : previous_item;
            }, -1);
            if (occurs >= 0) {
                previous[occurs].value = previous[occurs].value.concat(current);
            }
            else {
                let obj = {
                    [key]: current[key],
                    value: [current.value || current],
                };
                previous = previous.concat([obj]);
            }
            return previous;
        }, []);
        if ((sortKeys === null || sortKeys === void 0 ? void 0 : sortKeys.length) > 0) {
            output = FunctionSortArrayByArrayKeys(output, key, sortKeys);
        }
        if (select.length > 0) {
            return FunctionSelectFromMerge(output, key, select);
        }
        else {
            return output.map((item) => {
                return {
                    key: item[key],
                    value: item.value,
                };
            });
        }
    }
    catch (error) {
        console.error("FunctionGroupingArrayByKey : ", error);
    }
};
exports.FunctionGroupingArrayByKey = FunctionGroupingArrayByKey;
const FunctionMergeObjectByKey = (arrayData = [], key = "") => {
    try {
        var output = [];
        arrayData.forEach(function (item) {
            var occurs = output.filter((thisItem) => {
                return thisItem[key] === item[key];
            });
            if (occurs.length) {
                var appearIndex = output.indexOf(occurs[0]);
                output[appearIndex] = Object.assign(Object.assign({}, output[appearIndex]), item);
            }
            else {
                output.push(item);
            }
        });
        return output;
    }
    catch (error) {
        console.error("FunctionMergeObjectByKey : ", error);
    }
};
exports.FunctionMergeObjectByKey = FunctionMergeObjectByKey;
const FunctionChangCamelCaseToSnakeCase = (string) => {
    return string.replace(/([A-Z])/g, (g) => `_${g[0].toLowerCase()}`);
};
exports.FunctionChangCamelCaseToSnakeCase = FunctionChangCamelCaseToSnakeCase;
const FunctionChangeSnakeCaseToCamelCase = (string) => {
    return string.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
};
exports.FunctionChangeSnakeCaseToCamelCase = FunctionChangeSnakeCaseToCamelCase;
const FunctionChangeSnakeCaseToNormalCase = (string) => {
    const first = string === null || string === void 0 ? void 0 : string.slice(0, 1).toLocaleUpperCase();
    const last = string.replace(/([-_][a-z])/g, (group) => {
        return group.toUpperCase().replace("-", " ").replace("_", " ");
    });
    return first + last.slice(1);
};
exports.FunctionChangeSnakeCaseToNormalCase = FunctionChangeSnakeCaseToNormalCase;
const FunctionChnageCamelCaseToNormalCase = (value) => {
    return (value === null || value === void 0 ? void 0 : value.charAt(0).toUpperCase()) + (value === null || value === void 0 ? void 0 : value.slice(1).toLowerCase());
};
exports.FunctionChnageCamelCaseToNormalCase = FunctionChnageCamelCaseToNormalCase;
const FunctionChangeNormalCaseToCamelCase = (value) => {
    return value;
};
exports.FunctionChangeNormalCaseToCamelCase = FunctionChangeNormalCaseToCamelCase;
const FunctionChangeNormalCaseToSnakeCase = (value) => {
    return value;
};
exports.FunctionChangeNormalCaseToSnakeCase = FunctionChangeNormalCaseToSnakeCase;
const FunctionCheckDifferences = (obj1, obj2) => {
    const differences = {};
    for (const key in obj1) {
        if (obj1[key] !== obj2[key]) {
            if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
                // If both values are objects, compare them recursively
                const nestedDifferences = (0, exports.FunctionCheckDifferences)(obj1[key], obj2[key]);
                for (const nestedKey in nestedDifferences) {
                    differences[`${key}.${nestedKey}`] = nestedDifferences[nestedKey];
                }
            }
            else {
                // If the values are not both objects, add the key and value to the differences object
                differences[key] = [obj1[key], obj2[key]];
            }
        }
    }
    return differences;
};
exports.FunctionCheckDifferences = FunctionCheckDifferences;
const FunctionSelectFields = (objectData = {}, selectFields = []) => {
    if ((selectFields === null || selectFields === void 0 ? void 0 : selectFields.length) > 0) {
        const result = {};
        selectFields.forEach((key) => {
            if (objectData.hasOwnProperty(key)) {
                result[key] = objectData[key];
            }
            else {
                result[key] = "";
            }
        });
        return result;
    }
    else {
        return selectFields;
    }
};
exports.FunctionSelectFields = FunctionSelectFields;
const FunctionRemoveEmptyValue = (ObjectValue, ShowZero = true) => {
    const filteredEntries = Object.entries(ObjectValue).filter(([key, value]) => {
        return (value !== "" &&
            value !== null &&
            value !== undefined &&
            !Number.isNaN(value) &&
            (ShowZero ? true : value !== 0) &&
            value !== false);
    });
    return Object.fromEntries(filteredEntries);
};
exports.FunctionRemoveEmptyValue = FunctionRemoveEmptyValue;
const FunctionGetBlobFromFile = (file) => __awaiter(void 0, void 0, void 0, function* () { return new Blob([new Uint8Array(yield file.arrayBuffer())], { type: file.type }); });
exports.FunctionGetBlobFromFile = FunctionGetBlobFromFile;
